import { TestStatus } from "types/testTypes";

export const RUNNING_TEST_STATUSES: TestStatus[] = [
  TestStatus.StartRequested,
  TestStatus.Started,
  TestStatus.Paused,
  TestStatus.CompleteRequested,
  TestStatus.VirtualAssistant,
];

export const isTestStatusRunning = (status: TestStatus): boolean => {
  return RUNNING_TEST_STATUSES.includes(status);
};
